// src/helpers/api.ts
export const API_BASE_URL = process.env.REACT_APP_API_URL || "https://rasad-api.havirard.ir";

export const getAuthHeaders = () => {
    const token = localStorage.getItem("app_havir");
    return {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
    };
};